/**
 * Media-slot resolver for the field shapes that carry a media slot (action-set
 * items, highlights, workspace figures): each slot renders through the chart,
 * map or image element renderer, so there is one media boundary.
 */
import React from 'react';
import { FmChartElementView, FmImageElementView, FmMapElementView } from './FmMediaElements';
import type { FmStoryMediaSlot } from './elementMedia.types';

export const FmMediaSlotFigure: React.FC<{
  slot?: FmStoryMediaSlot;
  cropRole?: 'split' | 'card';
}> = ({ slot, cropRole = 'split' }) => {
  if (!slot) return <div className="fm-element-unavailable">Media slot unavailable.</div>;
  if (slot.kind === 'chart') {
    const { kind: _kind, ...chart } = slot;
    return <FmChartElementView element={{ element: 'chart', ...chart }} />;
  }
  if (slot.kind === 'image') {
    const { kind: _kind, ...image } = slot;
    return <FmImageElementView element={{ element: 'image', ...image }} cropRole={cropRole} />;
  }
  const { kind, ...map } = slot;
  return (
    <FmMapElementView
      element={{ element: 'map', ...map }}
      cropRole={cropRole}
      defaultTestId={`story-${kind}-media`}
    />
  );
};

FmMediaSlotFigure.displayName = 'FmMediaSlotFigure';
